import { z } from 'zod';
import { IndicatorConfigInputSchema } from './indicators-input';
import { StrategyConfigInputSchema } from './signals-input.schema';

export const TimeframeConfigInputSchema = z.object({
  timeframe: z.string(),
  historicalDays: z.number().optional(),
  fileName: z.string().optional(),
  indicators: z.array(IndicatorConfigInputSchema),
  strategy: StrategyConfigInputSchema.optional()
});

export type TimeframeConfigInput = z.infer<typeof TimeframeConfigInputSchema>;
